import * as Yup from "yup"

export const validationSchema = Yup.object({
  email: Yup.string().required("Please Enter Your User Email"),
  password: Yup.string().required("Please Enter Your Password"),
})
export const validationRegisterSchema = Yup.object({
  nickname: Yup.string().required("Please Enter Your Name"),
  email: Yup.string().required("Please Enter Your Email"),
  password: Yup.string().required("Please Enter Your Password"),
  role: Yup.string().required("Please Select User Role"),
})
